// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"60f2ddbc","488":"7cb953a1","977":"4eeefa10"}[chunkId] + ".chunk.js";
};